import { css, SerializedStyles } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { redditColors } from '../../styles/colors'

export const headlineWrapper = css({
  padding: '8px 0 16px 0',
})

export const headlineStyle = css({
  fontFamily: fonts.helvetica,
  fontSize: '18px',
  fontWeight: fontWeights.bold,
  lineHeight: '1.4',
  color: redditColors.darkText,
})

export const assetWrapper = css({
  width: '100%',
  overflow: 'hidden',
  backgroundColor: redditColors.border,
  borderRadius: '8px',
  '&[data-has-cta="true"]': {
    borderRadius: '8px 8px 0 0',
  },
})

export const getAssetStyles = (
  hasCtaBar: boolean
): { asset: SerializedStyles; assetBase: SerializedStyles } => {
  const borderRadius = hasCtaBar ? '8px 8px 0 0' : '8px'

  return {
    assetBase: css({
      overflow: 'hidden',
      width: '100%',
      borderRadius: borderRadius,
    }),
    asset: css({
      backgroundColor: redditColors.border,
      width: '100%',
      'img,video': {
        borderRadius: borderRadius,
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
      },
    }),
  }
}

export const emptyAssetPlaceholder = css({
  width: '100%',
  height: '400px',
  backgroundColor: redditColors.border,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: redditColors.iconGray,
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.medium,
})
